// extracted by mini-css-extract-plugin
module.exports = {"post":"S6_Blog_post__274qW"};